import React from 'react';
import { Table, Breadcrumb, Form, Button } from 'antd';
import { api, onGet } from '../../../../core/api3';
import HuobiInvestmentEditModal from './HuobiInvestmentEditModal';

const { Column } = Table;

class HuobiView extends React.Component {

    constructor() {
        super();
        this.state = {
            investments: [],
            profitLossRate: 0,
            profitLoss1: 0,
            profitLoss2: 0,
            consumeUsdt: 0,
            totalPrice: 0,
            modalVisible: false
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.onModalFinish = this.onModalFinish.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        onGet(api.listHuobi.url).then(response => {
            if (response === undefined) {
                return;
            }
            response.huobiList.forEach(investment => {
                investment.key = investment.symbol;
                investment.symbolStr = investment.symbol + '（' + investment.currentPrice + 'USDT）';
                investment.volume = investment.currentVolume + investment.symbol;
                investment.profitLoss1 = investment.profitLoss1 + 'USDT';
                investment.profitLoss2 = investment.profitLoss2 + 'USDT';
                investment.price1 = investment.price1 + 'USDT';
                investment.price2 = investment.price2 + 'USDT';
                investment.commission1 = investment.commission1 + investment.symbol;
                investment.commission2 = investment.commission2 + 'USDT';
                investment.consume_usdt = investment.consumeUsdt + 'USDT';
                investment.totalPrice = investment.totalPrice + '元';
            });
            this.setState({
                investments: response.huobiList,
                profitLossRate: (response.profitLossRate * 100).toFixed(2),
                profitLoss1: response.profitLoss1,
                profitLoss2: response.profitLoss2,
                consumeUsdt: response.consumeUsdt,
                totalPrice: response.totalPrice
            });
        });
    }

    onClick(type, item) {
        switch (type) {
            case 'add':
                this.setState({ modalVisible: true });
                break;
            case 'detail':
                this.props.history.push('/coin/huobi/detail?symbol=' + item.key);
                break;
            case 'profit-loss':
                window.open('http://profitloss.jinchim.com/');
                break;
            default:
                break;
        }
    }

    onModalClose() {
        this.setState({ modalVisible: false });
    }

    onModalFinish() {
        this.setState({ modalVisible: false }, () => {
            this.loadData();
        });
    }

    render() {
        return (
            <div>
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item><a href="#/index">首页</a></Breadcrumb.Item>
                    <Breadcrumb.Item>火币现货</Breadcrumb.Item>
                </Breadcrumb>
                <div className="content">
                    <Button type="primary" style={{ marginBottom: 20 }} onClick={() => this.onClick('add')}>添加</Button>
                    <span style={{ marginLeft: 50 }}>已实现盈亏：<span style={{ color: '#f00' }}>{this.state.profitLoss1}</span>USDT</span>
                    <span style={{ marginLeft: 30 }}>未实现盈亏：<span style={{ color: '#f00' }}>{this.state.profitLoss2}</span>USDT</span>
                    <span style={{ marginLeft: 30 }}>定投金额：<span style={{ color: '#f00' }}>{this.state.totalPrice}</span>元</span>
                    <a type="primary" style={{ marginLeft: 30 }} onClick={() => this.onClick('profit-loss')}>查看总收益走势图</a>
                    <Table dataSource={this.state.investments} pagination={false}>
                        <Column title="定投币种" dataIndex="symbolStr" align="center" />
                        <Column title="持仓量" dataIndex="volume" align="center" />
                        <Column title="已实现盈亏" dataIndex="profitLoss1" align="center" />
                        <Column title="未实现盈亏" dataIndex="profitLoss2" align="center" />
                        <Column title="买入均价" dataIndex="price1" align="center" />
                        <Column title="卖出均价" dataIndex="price2" align="center" />
                        <Column title="买入手续费" dataIndex="commission1" align="center" />
                        <Column title="卖出手续费" dataIndex="commission2" align="center" />
                        <Column title="定投金额" dataIndex="totalPrice" align="center" />
                        <Column title="操作" align="center" render={item => (
                            <span>
                                <a onClick={() => this.onClick('detail', item)} >详情</a>
                            </span>
                        )} />
                    </Table>
                </div>
                {this.state.modalVisible &&
                    <HuobiInvestmentEditModal isAdd={true} onModalCancel={this.onModalClose} onModalFinish={this.onModalFinish} />
                }
            </div>
        );
    }

}

const HuobiPage = Form.create()(HuobiView);
export default HuobiPage;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/huobi/HuobiPage.jsx